import { breakPoint } from './mediaquery'

const loading = document.querySelector('.loading')
const loadingLogoPath01 = document.querySelector('.loading-logo_path01')
const loadingLogoPath02 = document.querySelector('.loading-logo_path02')
const loadingLogoPath03 = document.querySelector('.loading-logo_path03')
const loadingLogoPath04 = document.querySelector('.loading-logo_path04')
const loadingLogoPath05 = document.querySelector('.loading-logo_path05')
const loadingLogoPath06 = document.querySelector('.loading-logo_path06')
const loadingLogoPath07 = document.querySelector('.loading-logo_path07')
const loadingLogoPath08 = document.querySelector('.loading-logo_path08')
const loadingLogoPath09 = document.querySelector('.loading-logo_path09')

const firstLoadingLogoInit = () => {
  const pathInit = (element) => {
    const length = element.getTotalLength()
    element.style.strokeDasharray = length
    element.style.strokeDashoffset = length
  }
  pathInit(loadingLogoPath01)
  pathInit(loadingLogoPath02)
  pathInit(loadingLogoPath03)
  pathInit(loadingLogoPath04)
  pathInit(loadingLogoPath05)
  pathInit(loadingLogoPath06)
  pathInit(loadingLogoPath07)
  pathInit(loadingLogoPath08)
  pathInit(loadingLogoPath09)
}

/**
 * first loading
 */
export const firstLoading = (namespace) => {
  const getTotalLength01 = loadingLogoPath01.getTotalLength()
  const getTotalLength02 = loadingLogoPath02.getTotalLength()
  const getTotalLength03 = loadingLogoPath03.getTotalLength()
  const getTotalLength04 = loadingLogoPath04.getTotalLength()
  const getTotalLength05 = loadingLogoPath05.getTotalLength()
  const getTotalLength06 = loadingLogoPath06.getTotalLength()
  const getTotalLength07 = loadingLogoPath07.getTotalLength()
  const getTotalLength08 = loadingLogoPath08.getTotalLength()
  const getTotalLength09 = loadingLogoPath09.getTotalLength()
  imagesLoaded(document.querySelector('.main'), () => {
    firstLoadingLogoInit()
    /**
     * ブレイクポイントでアニメーション切り替え
     * @param e
     */
    const changeBreakPoint = (e) => {
      if (!e.matches && namespace === 'top') {
        /**
         * mobile
         * topページ
         */
        gsap
          .timeline()
          .set('.loading-logo', {
            opacity: 1,
          })
          .to(
            loadingLogoPath01,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.1
          )
          .to(
            loadingLogoPath02,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.15
          )
          .to(
            loadingLogoPath03,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.2
          )
          .to(
            loadingLogoPath04,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.25
          )
          .to(
            loadingLogoPath05,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.3
          )
          .to(
            loadingLogoPath06,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.35
          )
          .to(
            loadingLogoPath07,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.4
          )
          .to(
            loadingLogoPath08,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.45
          )
          .to(
            loadingLogoPath09,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.5
          )
          .to(
            '.loading-logo',
            {
              duration: 0.5,
              ease: 'power3.out',
              opacity: 0,
            },
            1
          )
          .to(
            '.loading-bg',
            {
              duration: 2,
              ease: 'power4.out',
              opacity: 0.9,
            },
            1.2
          )
          .to(
            '.loading-operation',
            {
              duration: 1,
              ease: 'expo.out',
              opacity: 1,
            },
            1.5
          )
          .to(
            '.loading-operation svg',
            {
              duration: 2,
              ease: 'expo.out',
              y: '0',
            },
            1.6
          )
          .to(
            '.loading',
            {
              duration: 1,
              ease: 'expo.out',
              opacity: 0,
              onComplete: () => {
                loading.remove()
              },
            },
            2.5
          )
      } else if (!e.matches && namespace !== 'top') {
        /**
         * mobile
         * topページ以外
         */
        gsap
          .timeline()
          .set('.loading-logo', {
            opacity: 1,
          })
          .to(
            loadingLogoPath01,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.1
          )
          .to(
            loadingLogoPath02,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.15
          )
          .to(
            loadingLogoPath03,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.2
          )
          .to(
            loadingLogoPath04,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.25
          )
          .to(
            loadingLogoPath05,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.3
          )
          .to(
            loadingLogoPath06,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.35
          )
          .to(
            loadingLogoPath07,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.4
          )
          .to(
            loadingLogoPath08,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.45
          )
          .to(
            loadingLogoPath09,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.5
          )
          .to('.loading', {
            duration: 1,
            ease: 'expo.out',
            opacity: 0,
            onComplete: () => {
              loading.remove()
            },
          })
      } else {
        /**
         * pcのみ
         */
        gsap
          .timeline()
          .set('.loading-logo', {
            opacity: 1,
          })
          .to(
            loadingLogoPath01,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.1
          )
          .to(
            loadingLogoPath02,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.15
          )
          .to(
            loadingLogoPath03,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.2
          )
          .to(
            loadingLogoPath04,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.25
          )
          .to(
            loadingLogoPath05,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.3
          )
          .to(
            loadingLogoPath06,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.35
          )
          .to(
            loadingLogoPath07,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.4
          )
          .to(
            loadingLogoPath08,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.45
          )
          .to(
            loadingLogoPath09,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: 0,
            },
            0.5
          )
          .to(
            loadingLogoPath01,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: getTotalLength01 * -1,
            },
            0.6
          )
          .to(
            loadingLogoPath02,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: getTotalLength02 * -1,
            },
            0.65
          )
          .to(
            loadingLogoPath03,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: getTotalLength03 * -1,
            },
            0.7
          )
          .to(
            loadingLogoPath04,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: getTotalLength04 * -1,
            },
            0.75
          )
          .to(
            loadingLogoPath05,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: getTotalLength05 * -1,
            },
            0.8
          )
          .to(
            loadingLogoPath06,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: getTotalLength06 * -1,
            },
            0.85
          )
          .to(
            loadingLogoPath07,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: getTotalLength07 * -1,
            },
            0.9
          )
          .to(
            loadingLogoPath08,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: getTotalLength08 * -1,
            },
            0.95
          )
          .to(
            loadingLogoPath09,
            {
              duration: 0.5,
              ease: 'power4.out',
              strokeDashoffset: getTotalLength09 * -1,
            },
            1
          )
          .to('.loading', {
            duration: 1,
            ease: 'expo.out',
            opacity: 0,
            onComplete: () => {
              loading.remove()
            },
          })
          .to(
            '.body-bg span',
            {
              duration: 0.75,
              ease: 'expo.out',
              stagger: 0.02,
              x: 0,
              onComplete: () => {
                gsap.set('.body-bg span', {
                  willChange: 'auto',
                })
              },
            },
            1.5
          )
          .to(
            '.header',
            {
              duration: 0.8,
              ease: 'expo.out',
              x: 0,
              onComplete: () => {
                gsap.set('.header', {
                  willChange: 'auto',
                })
              },
            },
            1.6
          )
          .to(
            '.search',
            {
              duration: 0.8,
              ease: 'expo.out',
              x: 0,
              opacity: 1,
              onComplete: () => {
                gsap.set('.search', {
                  willChange: 'auto',
                })
              },
            },
            1.7
          )
          .to(
            '.wrapper',
            {
              duration: 1,
              ease: 'expo.out',
              autoAlpha: 1,
            },
            2
          )
          .to(
            '.top-prev',
            {
              duration: 1,
              ease: 'expo.out',
              autoAlpha: 1,
            },
            2
          )
          .to(
            '.top-next',
            {
              duration: 1,
              ease: 'expo.out',
              autoAlpha: 1,
            },
            2
          )
          .to(
            '.header-inner',
            {
              duration: 1,
              ease: 'expo.out',
              autoAlpha: 1,
            },
            2
          )
          .to(
            '.search-inner',
            {
              duration: 1,
              ease: 'expo.out',
              autoAlpha: 1,
            },
            2
          )
      }
    }
    changeBreakPoint(breakPoint)
    breakPoint.addListener(changeBreakPoint)
  })
}

export const secondLoading = () => {
  imagesLoaded(document.querySelector('.main'), () => {
    gsap
      .timeline()
      .set('.body-bg span', {
        x: 0,
        willChange: 'auto',
      })
      .set('.header', {
        x: 0,
        willChange: 'auto',
      })
      .set('.search', {
        x: 0,
        opacity: 1,
        willChange: 'auto',
      })
      .set('.wrapper', {
        autoAlpha: 1,
      })
      .set('.wrapper', {
        autoAlpha: 1,
      })
      .set('.wrapper', {
        autoAlpha: 1,
      })
      .set('.top-prev', {
        autoAlpha: 1,
      })
      .set('.top-next', {
        autoAlpha: 1,
      })
      .set('.header-inner', {
        autoAlpha: 1,
      })
      .set('.search-inner', {
        autoAlpha: 1,
      })
      .to('.loading', {
        delay: 0.1,
        duration: 1.1,
        ease: 'expo.out',
        opacity: 0,
        onComplete: () => {
          loading.remove()
        },
      })
  })
}
